module.exports = __webpack_public_path__ + "fonts/BC-Liguria.7206ccd7.ttf";